import type { Ref, RefCallback } from 'react';

export function mergeRefs<T>(...refs: Array<Ref<T> | undefined>): RefCallback<T> {
    return (node) => {
        const cleanups = refs.map((ref) => {
            if (typeof ref === 'function') {
                const cleanup = ref(node);
                return typeof cleanup === 'function' ? cleanup : () => ref(null);
            }
            if (ref) {
                ref.current = node;
                return () => {
                    ref.current = null;
                };
            }
            return undefined;
        });
        return () => {
            for (const cleanup of cleanups) {
                cleanup?.();
            }
        };
    };
}
